import React from 'react';
import { Auth0Provider as Provider } from '@auth0/auth0-react';

const Auth0Provider = props => {
	const { children } = props;
	const propsToPass = { ...props };
	delete propsToPass.children;

	return (
		<Provider
			domain="blueprint-nyc.auth0.com"
			clientId="F8wIGfq1Z9ZC30BeRaKqIilc7wIAKLwv"
			redirectUri={window.location.origin + '/auth0callback'}
			audience="https://blueprint-nyc.auth0.com/api/v2/"
			scope="read:current_user update:current_user_metadata"
			useRefreshTokens={true}
		>
			{React.cloneElement(children, propsToPass)}
		</Provider>
	);
};

export default Auth0Provider;
